import styles from './Header.module.css'
import { Svg3PointsMore, SvgLogoMetropole } from '../svg/SvgComponents'
import { getToken } from '../../utils/sessionManagement'
import DropdownProfile from '../DropdownProfile/DropdownProfile'
import { Link } from 'react-router-dom'

function Header({ isAnswersResponse }) {
  const isUserLoggedIn = !!getToken()

  return (
    <header className={styles.navbar_v1}>
      <div className={styles.navbar_v1__wrapper}>
        <div className={styles.navbar_v1_main}>
          <a href={`/workspaces/`} rel="noopener noreferrer">
            <div className={styles.container_logo}>
              <div className={styles.logo_more}>
                <Svg3PointsMore />
              </div>
              <div className={styles.logo_metropole}>
                <SvgLogoMetropole />
              </div>
            </div>
          </a>
        </div>

        <div className={styles.navbar_v1_logo}>
          <div className={styles.logo_name}>forma</div>
        </div>

        <div className={styles.navbar_v1_dynamic}>
          <div className={styles.navbar_v1_dynamic__logged}>
            {!isAnswersResponse &&
              (isUserLoggedIn ? (
                <Link to={'/create-form'}>
                  <button className={styles.createButton}>
                    Créer un formulaire
                  </button>
                </Link>
              ) : (
                <Link to={'/login'}>
                  <button className={styles.createButton}>Se connecter</button>
                </Link>
              ))}

            {isUserLoggedIn && (
              <div className={styles.profile}>
                <DropdownProfile />
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
